import React, { Component } from 'react';
import { notification, Modal } from 'antd/lib';
import FormDatosEmail from './FormDatosEmail';
import { withApollo, graphql, compose } from 'react-apollo';

import enviarActuacionPorEmail from '../../../../graphql/mutations/common/enviarActuacionPorEmail.graphql';
import getOrganismos from '../../../../graphql/querys/organismos/getOrganismos.graphql';

@compose(
  graphql(getOrganismos, {
    name: 'getOrganismos',
  }),
  graphql(enviarActuacionPorEmail, { name: 'enviarActuacionPorEmail' })
)
class ModalMandarEmail extends Component {
  state = {
    articulosParaSancionar: [],
    cantidadJus: 0,
    montoSancion: 0,
    montoAdicional: 0,
  };

  handleOk = datos => {
    this.props
      .enviarActuacionPorEmail({
        variables: {
          _id: this.props.idDocumento,
          emailDestino: datos.emailDestino + '@jusneuquen.gov.ar',
          cuerpo: datos.cuerpo,
        },
      })
      .then(res => {
        // console.log('LA RESPUESTA Q RECIBO ES: ', res);

        if (res) {
          notification.success({
            message: 'El email se ha enviado correctamente.',
          });

          this.props.ocultarModalMandarEmail();
        } else {
          notification.error({
            message: 'Error a la hora de enviar el email, intente nuevamente.',
          });
        }
      })
      .catch(err => {
        console.log('ERROR AL ENVIAR EL EMAIL: ', err);
        notification.error({
          message: 'Error a la hora de enviar el email, intente nuevamente.',
        });
      });
  };

  render() {
    // console.log('PROPS');
    // console.log(this.props);

    // console.log('EL JUS: ', jus);
    // console.log('MONTO: ', this.state.montoSancion);

    let organismos = this.props.getOrganismos.getOrganismos;
    if (organismos && !organismos.length) {
      return null;
    }
    return (
      <div>
        <Modal
          title="Enviar Documento por Email"
          visible={this.props.visibleModalMandarEmail}
          onCancel={this.props.ocultarModalMandarEmail}
          onOk={this.handleOk}
          width={800}
          style={{ width: 600 }}
          footer={[]}
        >
          <FormDatosEmail onSubmit={this.handleOk} organismos={organismos} />
        </Modal>
      </div>
    );
  }
}

export default withApollo(ModalMandarEmail);
